<div class="header-container" [class.left]="position === 'normal'" [class.right]="position === 'inverse'">
  <div class="logo-containter">
    <a (click)="toggleSidebar()" href="#" class="navigation"><i class="nb-menu"></i></a>
    <div class="logo" (click)="goToHome()">
      <!-- <img class="brand" src="assets/images/logo.png"/> -->
      <kw-image [imageHeight]="'50'" [imageId]="'HeaderLogo'">

      </kw-image>
    </div>
  </div>
</div>

<div class="header-container">

  <nb-actions size="medium">
    <nb-action *nbIsGranted="['view', 'user']">
      <nb-user (click)="logOut()" [nbContextMenu]="userMenu" [name]="user?.name" [picture]="user?.picture"></nb-user>
    </nb-action>
  </nb-actions>
</div>
